import React from "react";
import "./GlobalPromise.css";

const GlobalPromise = () => {
  return (
    <section className="global-section">
      <div className="section-container-bg section-container-p">
        <div className="section-container">
          <div className="section-row1">
            <div className="section-left about-All">
              <h1>Global Reach, Local Expertise</h1>
              <h2>Your Trusted Partner Worldwide</h2>
            </div>
            <div className="section-right about-All">
              <h6>
                Founded in the United States, we now support businesses in
                India, the UK, and Singapore. Our mission is to simplify
                valuations for businesses of every size, wherever they operate.
              </h6>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="section-container section-container-p">
          <div className="section-row2">
            <div className="section-left about-All">
              <h1>The Clybourne Promise</h1>
              <h2>Reliability, Innovation, and Customer-Centricity</h2>
            </div>
            <div className="section-right">
              <div className="promise-item ">
                <h4>Accuracy You Can Trust</h4>
                <h5>Precision-driven results tailored to your business.</h5>
              </div>
              <hr />
              <div className="promise-item ">
                <h4>Technology Meets Care</h4>
                <h5>Innovation simplified to suit your goals.</h5>
              </div>
              <hr />
              <div className="promise-item ">
                <h4>Client-First Approach</h4>
                <h5>Your success is our priority.</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalPromise;
